module.exports = __webpack_public_path__ + "img/tuev-logo.f556e96c.svg";